import { TransferTokenRequest } from "@kushki/js/lib/types/remote/transfer_token_request";
import { ErrorMessage } from "components/Error/ErrorMessageComponent";
import { Input } from "components/Input/InputComponent";
import { RadioGroup } from "components/RadioGroup/RadioGroupComponent";
import { Footer } from "components/UI/Footer/FooterComponent";
import { PayButton } from "components/UI/PayButton/PayButtonComponent";
import { Select } from "components/UI/Select/SelectComponent";
import {
  getBankList,
  getTransferToken,
  setDirty,
  updateInput,
  updateRadioGroup,
  updateSelectValue,
} from "containers/Transfer/store/ActionCreators";
import { TransferSubscriptionAccendo } from "containers/TransferSubscriptionAccendo/TransferSubscriptionAccendoComponent";
import { TransferSubscription } from "containers/TransferSubscriptions/TransferSubscriptionComponent";
import { get } from "lodash";
import * as React from "react";
// tslint:disable-next-line
import ReactGA, { EventArgs } from "react-ga";
import {
  LocalizeContextProps,
  Translate,
  withLocalize,
} from "react-localize-redux";
import { connect } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import { Dispatch } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { environment } from "root/environments/environment";
import { BANK_TRANSLATION_CODES } from "root/shared/BankCatalogEnum";
import { CurrencyEnum } from "root/shared/CurrencyEnum";
import { sendParametersToParent } from "root/shared/Messenger";
import { PaymenMethodEnum } from "root/shared/PaymenMethodEnum";
import { ProcessorNameEnum } from "root/shared/ProcessorNameEnum";
import {
  calculateTotalAmount,
  checkValidity,
  getTransferImage,
} from "root/shared/Utility";
import {
  CajitaStore,
  IInputProps,
  IRadioGroupProps,
  ISelectProps,
  ITransferFormProps,
} from "root/store/CajitaStore";
import { ITransferActionCreator } from "types/transfer_action_creator";
import { ITransferAmount } from "types/transfer_amount";

/**
 * Transfer StateFull Component
 */

class Transfer extends React.Component<
  ITransferFormProps & LocalizeContextProps
> {
  constructor(props: ITransferFormProps & LocalizeContextProps) {
    super(props);
    this.props.addTranslation(this.props.translation);
    this._inputHandler = this._inputHandler.bind(this);
    this._selectHandler = this._selectHandler.bind(this);
    this.__onRadioHandler = this.__onRadioHandler.bind(this);
    this._submitHandler = this._submitHandler.bind(this);
    ReactGA.initialize(environment.gaID);
  }
  public componentDidMount(): void {
    if (!this.props.is_subscription)
      this.props.getBankList(this.props.bankListSelect.id);
  }
  public componentDidUpdate(): void {
    if (this.props.token !== undefined && !this.props.is_subscription)
      sendParametersToParent({
        token: this.props.token,
        paymentMethod: PaymenMethodEnum.TRANSFER,
      });

    return;
  }

  // tslint:disable-next-line:cognitive-complexity
  public render(): React.ReactNode {
    return !this.props.isTransferAvailable ? (
      <div className={"container"}>
        <div className={"row text-center"}>
          <h4>
            <Translate id="notAvailableTransfer" />
          </h4>
        </div>
        {this.props.transferType === "Colombia" ? (
          <div className={"pseImage"} />
        ) : (
          ""
        )}
        <div className={"poweredBy"} />
      </div>
    ) : this.props.is_subscription &&
    this.props.currency === CurrencyEnum.MXN ? (
      <TransferSubscriptionAccendo />
    ) : this.props.is_subscription ? (
      <TransferSubscription />
    ) : (
      <form onSubmit={this._submitHandler} autoComplete="off" noValidate={true}>
        <ErrorMessage />
        <div id="box-details-pse">
          <div style={{ marginTop: 15 }}>
            <Container className="custom-container" fluid={true}>
              <Row>
                <Col xs={12}>
                  <div
                    className={getTransferImage(this.props.transferType)}
                    id={"transfer-image"}
                    style={{ marginBottom: 12 }}
                  />
                </Col>
                {this.props.transferType === "Mexico" ? (
                  <Col xs={12} fluid={true}>
                    <div className="subtitle-mxn-text font-size-14">
                      <Translate id="transferHelperMessage" />
                    </div>
                  </Col>
                ) : null}
              </Row>
            </Container>
          </div>
          {this.props.transferType === "Colombia"
            ? this._renderColombianInputs()
            : null}
          {this.props.transferType === "Chile" &&
          this.props.processorName === ProcessorNameEnum.ETPAYPLUS
            ? this._renderChileanInputs()
            : null}
          {this.props.transferType !== "Mexico" ? (
            <div style={{ paddingBottom: 20 }}>
              <Container className="custom-container" fluid={true}>
                <Row>
                  <Col xs={4} sm={4} md={2} lg={2} xl={2}>
                    <Select
                      {...this.props.documentTypeSelect}
                      change={this._selectHandler}
                      style={{ paddingLeft: 0 }}
                      required={this.props.transferType !== "Mexico"}
                    />
                  </Col>
                  <Col
                    xs={8}
                    sm={8}
                    md={10}
                    lg={10}
                    xl={10}
                    style={{ paddingLeft: 0 }}
                  >
                    <Input
                      {...this.props.documentNumberInput}
                      change={this._inputHandler}
                      touched={this.props.onTouched}
                      required={this.props.transferType !== "Mexico"}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          ) : null}
          <div>
            <Container className="custom-container" fluid={true}>
              <Row>
                <Col xs={12}>
                  <Input
                    {...this.props.documentEmailInput}
                    change={this._inputHandler}
                    touched={this.props.onTouched}
                    required={this.props.transferType === "Chile"}
                  />
                </Col>
              </Row>
            </Container>
          </div>
          <div className="section">
            <Row>
              <Col xs={12}>
                <Input
                  {...this.props.paymentDescriptionInput}
                  change={this._inputHandler}
                  touched={this.props.onTouched}
                />
              </Col>
            </Row>
          </div>
        </div>
        <PayButton
          isValid={this.props.isValid}
          totalAmount={this.props.totalAmount}
          isSubscription={false}
          currency={this.props.currency}
          isPayin={this.props.transferType === "Mexico"}
          disable={this.props.disablePayButton}
        />
        <Footer
          showLanguajeToggle={this.props.isLanguageToggleAvailable}
          showPseDocumentation={this.props.transferType === "Colombia"}
        />
      </form>
    );
  }

  private _renderColombianInputs(): JSX.Element {
    return (
      <>
        <Container className="custom-container" fluid={true}>
          <Row>
            <Col xs={12} fluid={true}>
              <Select
                {...this.props.bankListSelect}
                change={this._selectHandler}
                translationTargets={BANK_TRANSLATION_CODES}
                required={this.props.transferType === "Colombia"}
              />
            </Col>
          </Row>
        </Container>
        <div style={{ paddingBottom: 20 }}>
          <Container className="custom-container" fluid={true}>
            <Row>
              <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                <div className="transfer-subscription-account-label-container">
                  <span className="pse-label toggle-left transfer-subscription-account-label">
                    <Translate id="userTypeRadioGroupLabel" />
                  </span>
                </div>
              </Col>
              <Col
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                style={{ margin: "auto" }}
              >
                <div className={"shared-div"}>
                  <RadioGroup
                    {...this.props.userTypeRadioGroup}
                    clicked={this.__onRadioHandler}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }

  private _renderChileanInputs(): JSX.Element {
    return (
      <>
        <Container className="custom-container" fluid={true}>
          <Row>
            <Col xs={12} fluid={true}>
              <Select
                {...this.props.bankListSelect}
                change={this._selectHandler}
                translationTargets={BANK_TRANSLATION_CODES}
              />
            </Col>
          </Row>
        </Container>
      </>
    );
  }
  private _selectHandler(id: string, newValue: string): void {
    const new_select: ISelectProps = { ...this.props[id] };

    new_select.value = newValue;
    if (this.props.transferType === "Chile") {
      const etpay_bank:
        | { value: string; text: string }
        | undefined = new_select.inputItems.find(
        (input: { value: string; text: string }) => input.value === newValue
      );
      const options: EventArgs = {
        category: "Seleccionar Banco",
        action: "click",
        label: get(etpay_bank, "text", ""),
      };

      ReactGA.event(options);
    }
    this.props.onSelectChanged(new_select);
  }

  private __onRadioHandler(id: string, newSelected: string): void {
    const new_radio: IRadioGroupProps = { ...this.props[id] };

    new_radio.selected = newSelected;
    this.props.toggleUserType(new_radio);
  }

  private _inputHandler(id: string, newValue: string): void {
    const new_input: IInputProps = { ...this.props[id] };

    if (new_input.attributes.id === "documentEmailInput") {
      new_input.rules.required = true;
      new_input.rules.isEmail = {};
    }

    new_input.valid = checkValidity(newValue, new_input.rules);
    new_input.value = newValue;

    this.props.onChangeInput(new_input);
  }

  private _submitHandler(event: React.FormEvent<HTMLFormElement>): void {
    event.preventDefault();

    this.props.tokens({
      amount: this.props.amount,
      bankId:
        this.props.transferType !== "Colombia" &&
        this.props.transferType !== "Chile"
          ? undefined
          : this.props.bankListSelect.value,
      callbackUrl: this.props.callbackUrl,
      documentNumber: this.props.documentNumberInput.value,
      documentType: this.props.documentTypeSelect.value,
      paymentDescription: this.props.paymentDescriptionInput.value,
      email: this.props.documentEmailInput.value,
      userType: this.props.userTypeRadioGroup.selected,
      currency: this._getTransferCurrency(this.props.transferType),
    });
  }
  private _getTransferCurrency(currency: string): string {
    switch (currency) {
      case "Colombia":
        return "COP";
      case "Mexico":
        return "MXN";
      case "Chile":
        return "CLP";
      case "Peru":
        return "PEN";
      case "Ecuador":
        return "USD";
      default:
        return "";
    }
  }
}

const mapStateToProps: (state: CajitaStore) => ITransferFormProps = (
  state: CajitaStore
): ITransferFormProps => ({
  ...state.transfer,
  is_subscription: state.config.is_subscription,
  totalAmount: calculateTotalAmount(state.config.amount as ITransferAmount),
  amount: state.config.amount,
  callbackUrl: state.config.callback_url,
  isLanguageToggleAvailable: true,
  currency: state.config.currency,
  disablePayButton: state.config.disablePayButton,
});

const mapDispatchToProps: (dispatch: Dispatch) => object = (
  dispatch: ThunkDispatch<CajitaStore, undefined, ITransferActionCreator>
): object => ({
  onChangeInput: (payload: IInputProps): void => dispatch(updateInput(payload)),
  onTouched: (payload: IInputProps): ITransferActionCreator =>
    dispatch(setDirty(payload)),
  onSelectChanged: (payload: ISelectProps): void =>
    dispatch(updateSelectValue(payload)),
  toggleUserType: (payload: IRadioGroupProps): ITransferActionCreator =>
    dispatch(updateRadioGroup(payload)),
  tokens: (payload: TransferTokenRequest): void =>
    dispatch(getTransferToken(payload)),
  getBankList: (id: string): void => dispatch(getBankList(id)),
});

const TransferComponent: React.ComponentClass = connect(
  mapStateToProps,
  mapDispatchToProps
)(withLocalize<ITransferFormProps & LocalizeContextProps>(Transfer));

export { TransferComponent };



// WEBPACK FOOTER //
// ./src/containers/Transfer/TransferComponent.tsx